













import { Vue, Component, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { DateMessage } from '@/types/message'
import dayjs from 'dayjs'

@Component({
  components: {
    MessageHistoryLog: () =>
      import('@/components/message/MessageHistoryLog.vue'),
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class MessageHistory extends Vue {
  $store!: ExStore

  @Prop() dateMessage!: DateMessage

  get dateStr() {
    return dayjs(this.dateMessage.date).format('M月D日')
  }
}
